import React from 'react';
import NavigationMenuSection from "../../menu-items/section/section";
import NavigationMenuItemUrl from "../../menu-items/menu-item-url";
import NavigationMenu_AllReportsItem from "./all-reports-item"
import {AppZenCompanyId} from "../../../../views/reports/custom-reports/app-zen/model/@const";
import MainMenu_SectionReorderableWithMore from "../../components/menu-controller/menu-section-reordable-with-more";
import NavigationMenuAdd from "../../menu-items/menu-add/menu-add";
import ModalReportSelect from "../../../../app/project/reports/modal/modal-report-select";
import Report from "../../../../core/model2/report/report";
import ApiProject from "../../../../core/gd/api/project";
import {SpaceReports} from "../../../../core/model2/space/system/reports";
import ProjectSession from "../../../../core/model2/project/project-session";
import NavigationMenu_ItemReport from "../../menu-items/report/menu-item-report";
import ArrayUtils from "../../../../core/gd/utils/array";
import {MenuComponentProps} from "../const";

export default function NavigationMenu_ReportsContent(props: MenuComponentProps) {

    const spaceReports = new SpaceReports();

    const components: any[] = _.map(spaceReports.reports, (report: ProjectSession, key: number)=>({
        item        : report,
        component   : <NavigationMenu_ItemReport key        = {key}
                                                 level      = {0}
                                                 dndPreview = {false}
                                                 report     = {report}/>
    }))

    const menuItems = _(components)
        .orderBy([
            component=>ArrayUtils.indexOrder(gd.user.menu.myReports.sortPositions, component.item.id), // try to order by sort position
        ], ['asc'])
        .value();

    const onClickNew = ()=> {
        gd.modal.showV4({
            className       : 'modal-new-version-released',
            component       : ModalReportSelect,
            params          : {
                onSubmit    : async (report: Report)=>{
                    gd.modal.hide()

                    try {
                        const response = await ApiProject.newReportView({
                            name            : report.name,
                            projectIcon     : "report",
                            properties      : {customViewType  : report.type},
                            settings        : {
                                customView      : {
                                    settings        : report.settings,
                                    type            : report.type,
                                    tableSettings   : (report as any).defaultTableSettings
                                }
                            }
                        }).promise()

                        gd.navigation.goToProject(response.projectId, "")

                    } catch (e) {
                        console.error(e)
                    }
                }
            }
        });
    }

    const onReorderEnd = (items:any) => {
        gd.user.menu.myReports.sortPositions = items.map((item:any)=>item.id);
        gd.user.menu.save();
    };


    return (
        <>
            <NavigationMenuSection collapsible={false} systemName="reports-top">

                <NavigationMenu_AllReportsItem navigationSection={gd.spaces.reports.navigation}/>

                {gd.companyId === AppZenCompanyId && (
                    <NavigationMenuItemUrl name                 = "Custom reports"
                                           icon                 = "i5-widget-report"
                                           url                  = {'o/reports/custom-reports'}
                                           navigationSection    = {gd.spaces.reports.navigation}/>
                )}

                <NavigationMenuItemUrl name                 = "Saved Reports"
                                       icon                 = "i5-pie-chart"
                                       url                  = {"o/reports/saved"}
                                       navigationSection    = {gd.spaces.reports.navigation} />

            </NavigationMenuSection>

            <NavigationMenuSection name         = "My Reports"
                                   collapsible  = {true}
                                   counter      = {menuItems.length}
                                   systemName   = "my-reports">

                <MainMenu_SectionReorderableWithMore countVisibleItems  = {8}
                                                     moreTitle          = "All Reports"
                                                     newItemTitle       = "New Report"
                                                     components         = {menuItems}
                                                     settingsKey        = "reports-reports"
                                                     showAdd            = {false}
                                                     onReorderEnd       = {onReorderEnd}/>

                <NavigationMenuAdd name="New Report" onClick={onClickNew}/>

            </NavigationMenuSection>
        </>
    );
}
